import { gql } from '@apollo/client';

export const PaginationFragment = gql`
    fragment PaginationFragment on Pagination {
        totalCount
        page
        pageCount
    }
`;

/* Rider */

export const Rider_LocationFragment = gql`
    fragment Rider_LocationFragment on Rider_Location {
        latitude
        longitude
        timestamp
    }
`;

export const Rider_AttachmentFragment = gql`
    fragment Rider_AttachmentFragment on Rider_Attachment {
        uid
        size
        name
        type
        url
    }
`;

export const Payment_MethodFragment = gql`
    fragment Payment_MethodFragment on Payment_Method {
        paymentCash
        paymentProvider
        paymentMobile
    }
`;
export const PrivacyFragment = gql`
    fragment PrivacyFragment on Privacy {
        emailMarketing
        pushNotifications
        updateFeatures
        serveysRequest
        serviceUpdates
    }
`;

export const IdCardMetaDataFragment = gql`
    fragment IdCardMetaDataFragment on Rider_IdCardMetaData {
        documentName
        ICAOCode
        dCountryName
        dDescription
        dYear
    }
`;

export const RidePassFragment = gql`
    fragment RidePassFragment on RidePass {
        _id
        logicalId
        name
        description
        priceUnit
        discount
        duration
        initialPrice
        startDate
        endDate
        vehiculeType
        unlockPrice
        minutePrice
    }
`;

/* Taxi Driver */

export const TaxiDriver_AttachmentFragment = gql`
    fragment Rider_AttachmentFragment on Rider_Attachment {
        uid
        size
        name
        type
        url
    }
`;

export const TaxiDriverFragment = gql`
    ${Rider_AttachmentFragment}
    ${Rider_LocationFragment}
    ${PrivacyFragment}
    fragment TaxiDriverFragment on TaxiDriver {
        _id
        logicalId
        fullName
        birthday
        phoneNumber
        email
        driverPhoto {
            ...Rider_AttachmentFragment
        }
        referralCode
        privacy {
            ...PrivacyFragment
        }
        usedReferralCode
        marque
        model
        year
        immatriculation
        color
        idCard
        licenseNumber
        bankName
        bankAccountNumber
        documentsPhotos {
            ...Rider_AttachmentFragment
        }
        isDriverOnline
        fcmToken
        totalRides
        rating
        currentLocation {
            ...Rider_LocationFragment
        }
        registerStatus
        accountStatus
        expiredInsuranceDate
        expiredAccountDate
        isExpiredInsurance
        isRewardedReferral
        rewardedReferralCount
        commissionRate
        workRangeKm
        createdDate
        refreshToken
        language
        monthlyFee
        signUpType
        note
        mobileAppVersion
    }
`;

export const RiderFragment = gql`
    ${Rider_AttachmentFragment}
    ${Payment_MethodFragment}
    ${PrivacyFragment}
    ${IdCardMetaDataFragment}
    ${Rider_LocationFragment}
    fragment RiderFragment on Rider {
        _id
        fullName
        email
        phoneNumber
        birthday
        gender
        country
        currentLocation {
            ...Rider_LocationFragment
        }
        riderPhoto {
            ...Rider_AttachmentFragment
        }
        isPaymentDefaultMethod
        walletBalance
        paymentMethod {
            ...Payment_MethodFragment
        }
        isLogged
        signingMethod
        idProvider
        privacy {
            ...PrivacyFragment
        }
        idCardMetaData {
            ...IdCardMetaDataFragment
        }
        riderSelfie {
            ...Rider_AttachmentFragment
        }
        identityCheck
        attemptsCancel
        lastAttemptDate
        fcmToken
        refreshToken
        language
        mobileAppVersion
        createdDate
    }
`;

/* Plan taxi request */
export const PlanTaxiCoordinatesFragment = gql`
    fragment PlanTaxiCoordinatesFragment on PlanTaxi_Coordinates {
        longitude
        latitude
    }
`;

export const PlanTaxiLocationFragment = gql`
    ${PlanTaxiCoordinatesFragment}
    fragment PlanTaxiLocationFragment on PlanTaxi_Location {
        type
        coordinates {
            ...PlanTaxiCoordinatesFragment
        }
        label
    }
`;

export const PlanTaxiRequestDiscountFragment = gql`
    fragment PlanTaxiRequestDiscountFragment on PlanTaxi_Discount_Fragment {
        type
        amount
        reduction
        fareCoveredByCompany
        finalFare
        couponId
    }
`;

/* taxi offer price */

export const TaxiOfferFragment = gql`
    ${TaxiDriverFragment}
    ${PlanTaxiLocationFragment}
    fragment TaxiOfferFragment on TaxiOffer {
        _id
        logicalId
        offerPrice
        isYourPrice
        planTaxiRequestId {
            _id
        }
        startTripCode
        distanceStartToEnd
        startLocation {
            ...PlanTaxiLocationFragment
        }
        endLocation {
            ...PlanTaxiLocationFragment
        }
        taxiDriver {
            ...TaxiDriverFragment
        }
        status
        distanceCurrentLocationToStart
    }
`;

export const PlanTaxiRequestFragment = gql`
    ${PlanTaxiLocationFragment}
    ${RiderFragment}
    ${TaxiOfferFragment}
    ${PlanTaxiRequestDiscountFragment}
    fragment PlanTaxiRequestFragment on PlanTaxiRequest {
        _id
        logicalId
        startLocation {
            ...PlanTaxiLocationFragment
        }
        endLocation {
            ...PlanTaxiLocationFragment
        }
        budget
        recommendedPrice
        note
        nbrePassenger
        passengerId {
            ...RiderFragment
        }
        status
        startTripCode
        distanceStartToEnd
        applied
        taxiOfferId {
            ...TaxiOfferFragment
        }
        discount {
            ...PlanTaxiRequestDiscountFragment
        }
        offerPrice
        isRated
    }
`;

/* Pricing */
export const PricingFragment = gql`
    fragment PricingFragment on Pricing {
        _id
        logicalId
        name
        note
        minutePrice
        unlockPrice
        vehiculeType
        level
    }
`;

/* Vehicule */

export const VehiculeCoordinatesFragment = gql`
    fragment VehiculeCoordinatesFragment on Vehicule_Coordinates {
        longitude
        latitude
    }
`;

export const VehiculeLocationFragment = gql`
    ${VehiculeCoordinatesFragment}
    fragment VehiculeLocationFragment on Vehicule_Location {
        type
        coordinates {
            ...VehiculeCoordinatesFragment
        }
    }
`;

export const VehiculeFragment = gql`
    ${VehiculeLocationFragment}
    ${PricingFragment}
    fragment VehiculeFragment on Vehicule {
        _id
        logicalId
        vehiculeType
        qrcode
        mileage
        status
        batteryLevel
        city
        powerType
        operatedDate
        location {
            ...VehiculeLocationFragment
        }
        operatorId
        pricingId {
            ...PricingFragment
        }
    }
`;

/* Trip */
export const LocationFragment = gql`
    fragment LocationFragment on Trip_Location {
        latitude
        longitude
    }
`;

export const TripAttachmentFragment = gql`
    fragment TripAttachmentFragment on Trip_Attachment {
        uid
        size
        name
        type
        url
    }
`;

export const TripFragment = gql`
    ${LocationFragment}
    ${TripAttachmentFragment}
    ${VehiculeFragment}
    ${RiderFragment}
    fragment TripFragment on Trip {
        _id
        logicalId
        startPoint {
            ...LocationFragment
        }
        endPoint {
            ...LocationFragment
        }
        startDate
        endDate
        status
        dropPhoto {
            ...TripAttachmentFragment
        }
        vehiculeId {
            ...VehiculeFragment
        }
        riderId {
            ...RiderFragment
        }
    }
`;

/* Operator */

export const OperatorAddressFragment = gql`
    fragment OperatorAddressFragment on Operator_Address {
        street
        postalCode
        city
        governorate
        country
    }
`;
export const OperatorAttachmentFragment = gql`
    fragment OperatorAttachmentFragment on Operator_AttachmentUploaded {
        uid
        size
        name
        type
        url
    }
`;
export const OperatorFragment = gql`
    ${OperatorAttachmentFragment}
    ${OperatorAddressFragment}
    fragment OperatorFragment on Operator {
        _id
        logicalId
        name
        website
        phone
        email
        description
        tva
        type
        address {
            ...OperatorAddressFragment
        }
        logo {
            ...OperatorAttachmentFragment
        }
        settingId {
            _id
            fullname
            email
            sectionRoles
        }
    }
`;

/* Setting */
export const SettingFragment = gql`
    ${OperatorFragment}
    fragment SettingFragment on Setting {
        _id
        logicalId
        fullname
        password
        email
        sectionRoles
        operatorId {
            ...OperatorFragment
        }
    }
`;

export const TokenResponseFragment = gql`
    fragment TokenResponseFragment on TokenResponse {
        accessToken
        operatorId
    }
`;

/* Pass */
export const PassFragment = gql`
    fragment PassFragment on Pass {
        _id
        logicalId
        name
        description
        priceUnit
        discount
        duration
        initialPrice
        unlockPrice
        minutePrice
        vehiculeType
    }
`;

/* Coupon */
export const CouponFragment = gql`
    fragment CouponFragment on Coupon {
        _id
        logicalId
        operatorId
        title
        description
        amount
        reduction
        code
        startingDate
        expirationDate
        isExpiredDate
        isMultiple
        isMultipleTarget
        status
        isUsed
        type
    }
`;

/* Campaign */
export const CampaignFragment = gql`
    fragment CampaignFragment on Campaign {
        _id
        logicalId
        title
        description
        targetAudience
        startingDate
        endDate
        status
    }
`;

/* Reports */
export const ReportsTripsFragment = gql`
    fragment ReportsTripsFragment on ReportTrip {
        year
        value
        category
    }
`;

export const ReportsCO2Fragment = gql`
    fragment ReportsCO2Fragment on ReportCO2 {
        month
        estimate
    }
`;

export const LoginMethodReportFragment = gql`
    fragment LoginMethodReportFragment on LoginMethodReport {
        loginMethod
        total
    }
`;

export const ReportsCountersFragment = gql`
    ${LoginMethodReportFragment}
    fragment ReportsCountersFragment on ReportCounters {
        totalTrips
        totalRiders
        totalMileage
        totalRevenue
        loginMethods {
            ...LoginMethodReportFragment
        }
    }
`;

export const statusDriversFragment = gql`
    fragment statusDriversFragment on statusDrivers {
        driverName
        driverPhoto
        isDriverOnline
        updatedDate
    }
`;

export const statusRidersFragment = gql`
    fragment statusRidersFragment on statusRiders {
        riderName
        riderPhoto
        isRiderOnline
        updatedDate
    }
`;

export const ReportsCountersTaxiDriverFragment = gql`
    ${statusDriversFragment}
    ${statusRidersFragment}
    fragment ReportsCountersTaxiDriverFragment on ReportCountersTaxiBusiness {
        totalCompletedTrips
        totalTaxiDrivers
        totalActiveAccountStatusDrivers
        totalPendingRegisterStatusDrivers
        totalDistance
        totalOnlineDrivers
        totalEarningsSubscription
        totalCouponCost
        totalTripsWithCoupon
        totalCommissionAmount
        netRevenue
        statusDrivers {
            ...statusDriversFragment
        }
        totalOnlineRiders
        statusRiders {
            ...statusRidersFragment
        }
    }
`;

/* Map */

export const CityMapCoordinatesFragment = gql`
    fragment CityMapCoordinatesFragment on CityMap_Coordinates {
        longitude
        latitude
    }
`;

export const LocationMapFragment = gql`
    ${CityMapCoordinatesFragment}
    fragment LocationMapFragment on CityMap_Location {
        type
        coordinates {
            ...CityMapCoordinatesFragment
        }
    }
`;

export const CoordZoneFragment = gql`
    fragment CoordZoneFragment on Zone_Coord {
        lat
        lng
    }
`;

export const ZonesFragment = gql`
    ${CoordZoneFragment}
    fragment ZonesFragment on Map_Zone {
        id_zone
        name_zone
        coord {
            ...CoordZoneFragment
        }
    }
`;
export const CityMapFragment = gql`
    ${LocationMapFragment}
    ${ZonesFragment}
    fragment CityMapFragment on CityMap {
        _id
        logicalId
        cityName
        location {
            ...LocationMapFragment
        }
        zones {
            ...ZonesFragment
        }
    }
`;
/* City */
export const CityFragment = gql`
    fragment CityFragment on City {
        _id
        logicalId
        country
        governorate
        cityName
        latitude
        longitude
    }
`;

/* Support */
export const SupportFragment = gql`
    {
        SupportAttachmentFragment
    }
    fragment SupportFragment on Support {
        email
        subject
        description
        file {
            ...SupportAttachmentFragment
        }
    }
`;
export const SupportAttachmentFragment = gql`
    fragment SupportAttachmentFragment on Support_AttachmentUploaded {
        uid
        size
        name
        type
        url
    }
`;

/* VehiculeProblem */

export const problemPhotosAttachmentFragment = gql`
    fragment problemPhotosAttachmentFragment on VehiculeProblem_AttachmentUploaded {
        uid
        size
        name
        type
        url
    }
`;
export const VehiculeProblemFragment = gql`
    ${problemPhotosAttachmentFragment}
    fragment VehiculeProblemFragment on VehiculeProblem {
        _id
        logicalId
        description
        qrCode
        status
        currentLocation {
            type
            coordinates {
                longitude
                latitude
            }
        }
        problemPhotos {
            ...problemPhotosAttachmentFragment
        }
    }
`;

/* welcome contact */
export const ContactFragment = gql`
    fragment ContactFragment on Contact {
        email
        subject
        firstName
        description
    }
`;

/* Invoice  */

export const InvoiceAttachmentFragment = gql`
    fragment InvoiceAttachmentFragment on InvoiceAttachment {
        uid
        size
        name
        type
        url
    }
`;

export const InvoiceFragment = gql`
    ${InvoiceAttachmentFragment}
    fragment InvoiceFragment on Invoice {
        _id
        logicalId
        amount
        tripDuration
        startDate
        endDate
        reference
        distance
        vehiculeIdentifier
        invoiceAttachment {
            ...InvoiceAttachmentFragment
        }
    }
`;

// trips history rider mgt
export const TripsRiderHistoryDataFragment = gql`
    ${InvoiceAttachmentFragment}
    fragment TripsRiderHistoryDataFragment on TripsRiderHistoryData {
        _id
        date
        reference
        taxiDriverFullName
        invoiceType
        status
        invoiceAttachment {
            ...InvoiceAttachmentFragment
        }
    }
`;

// trips history driver mgt
export const TripsDriverHistoryDataFragment = gql`
    ${InvoiceAttachmentFragment}
    fragment TripsDriverHistoryDataFragment on TripsDriverHistoryData {
        _id
        date
        reference
        riderFullName
        reviewRating
        reviewCompliment
        invoiceType
        status
        invoiceAttachment {
            ...InvoiceAttachmentFragment
        }
    }
`;

/* Pricing Taxi*/
export const CoordAreaFragment = gql`
    fragment CoordAreaFragment on Coord_Area {
        lat
        lng
    }
`;

export const AreasMapFragment = gql`
    ${CoordAreaFragment}
    fragment AreasMapFragment on Area_Map {
        id
        coord {
            ...CoordAreaFragment
        }
    }
`;

export const TimeSlotFragment = gql`
    fragment TimeSlotFragment on time_Slot {
        startTime
        endTime
        percentage
    }
`;

export const PricingTaxiFragment = gql`
    ${AreasMapFragment}
    ${TimeSlotFragment}
    fragment PricingTaxiFragment on PricingTaxi {
        _id
        logicalId
        serviceName
        selectedCity
        timeSlot {
            ...TimeSlotFragment
        }
        klmRange
        note
        areaMap {
            ...AreasMapFragment
        }
        zoneBasePercentage
    }
`;

export const BasicTaxiPricingFragment = gql`
    fragment BasicTaxiPricingFragment on BasicPricingTaxi {
        _id
        logicalId
        rangeName
        minDistance
        maxDistance
        pricePerKm
    }
`;

/* Request Booking */
export const RequestBookingFragment = gql`
    ${OperatorFragment}
    fragment RequestBookingFragment on RequestBooking {
        _id
        logicalId
        pickUpLocation
        dropOffLocation
        tripDate
        nbrePassenger
        nbreluggage
        passengerName
        passengerEmail
        passengerPhoneNumber
        note
        status
        operatorId {
            ...OperatorFragment
        }
    }
`;

export const WeeklyTripDriverFragment = gql`
    fragment WeeklyTripDriverFragment on WeeklyTripDriver {
        value
        completed
        canceled
        label
    }
`;

export const DriverTripsSummaryFragment = gql`
    ${WeeklyTripDriverFragment}
    fragment DriverTripsSummaryFragment on DriverTripsSummaryResponse {
        toDay
        bonus
        numberRides
        numberCanceledOffers
        distance
        earningSummary
        commissionRate
        commissionAmount
        weeklyTrips {
            ...WeeklyTripDriverFragment
        }
    }
`;

export const WeeklyTripRiderFragment = gql`
    fragment WeeklyTripRiderFragment on WeeklyTripRider {
        label
        completed
        canceled
    }
`;

export const RiderTripsSummaryFragment = gql`
    ${WeeklyTripRiderFragment}
    fragment RiderTripsSummaryFragment on RiderTripsSummaryResponse {
        completedTrips
        canceledTrips
        couponsUsed
        weeklyTrips {
            ...WeeklyTripRiderFragment
        }
    }
`;

export const CanceledJobDriverHistoryDataFragment = gql`
    fragment CanceledJobDriverHistoryDataFragment on CanceledJobDriverHistoryData {
        logicalId
        date
        riderName
        status
    }
`;

export const CanceledJobByDriverFragment = gql`
    ${CanceledJobDriverHistoryDataFragment}
    fragment CanceledJobByDriverFragment on CanceledJobDriverHistory {
        totalCount
        data {
            _id
            isCurrentMonth
            monthTitle
            data {
                ...CanceledJobDriverHistoryDataFragment
            }
        }
    }
`;

/* Financial Overview */

export const FinancialOverview_AttachmentFragment = gql`
    fragment FinancialOverview_AttachmentFragment on FinancialOverview_Attachment {
        uid
        size
        name
        type
        url
    }
`;

export const FinancialSummaryFragment = gql`
    fragment FinancialSummaryFragment on FinancialSummary {
        subscriptions
        commissions
        taxOnRevenue
        netAmount
    }
`;
export const PeriodFragment = gql`
    fragment PeriodFragment on Period {
        fromDate
        toDate
        label
    }
`;

export const FinancialOverviewFragment = gql`
    ${FinancialOverview_AttachmentFragment}
    ${PeriodFragment}
    ${FinancialSummaryFragment}
    fragment FinancialOverviewFragment on FinancialOverview {
        _id
        logicalId
        period {
            ...PeriodFragment
        }
        driversCount
        financialSummary {
            ...FinancialSummaryFragment
        }
        financialOverviewPdf {
            ...FinancialOverview_AttachmentFragment
        }
        createdDate
    }
`;
